<script lang="ts">
	import { getContext } from "svelte";
	import { twMerge } from "tailwind-merge";
	import type { AssetLoad } from "#lib/api/bundles.js";
	import Icon from "#lib/components/Icon.svelte";
	import TokenizedImage from "#lib/components/TokenizedImage.svelte";
	import TokenizedText from "#lib/components/TokenizedText.svelte";
	import type { ModuleItemProps } from "#lib/components/flow/viewer/types.js";
	import { getAssetRef, getIconUrl, getText } from "#lib/components/flow/viewer/utils.js";
	import type { TokenProvider } from "#lib/tokenProvider.js";
	import type { Writable } from "svelte/store";

	const tokenProvider: Writable<TokenProvider> = getContext("tokenProvider");
	const assets: Writable<Record<string, AssetLoad>> = getContext("assets");
	const { suite, module, mode, readOnly, classes, onShow }: ModuleItemProps = $props();

	const ref = $derived(getAssetRef($suite, module));
	const iconUrl = $derived(getIconUrl($assets, module.key, ref, mode));
	const text = $derived(getText($assets, module.key, ref, mode));

	function handleShow() {
		onShow?.(module);
	}
</script>

<button data-flow-button type="button" disabled={readOnly} onclick={handleShow} class={twMerge("flex w-full max-w-100 cursor-pointer flex-col overflow-hidden rounded-2xl bg-white p-0", classes.borderClass, classes.readOnlyClass)} class:!opacity-50={ref?.disabled}>
	<div class="relative flex aspect-[2.57] w-full grow items-center justify-center">
		<TokenizedImage provider={$tokenProvider} src={iconUrl} {mode} />
	</div>
	<div class="flex h-12 w-full items-center justify-between border-t border-gray-300 px-3 py-2.5">
		<div class="grow text-left text-sm font-semibold text-gray-900">
			<TokenizedText provider={$tokenProvider} {text} {mode} />
		</div>
		<Icon name="chevron-right" class="h-5 w-5 text-gray-400" />
	</div>
</button>
